export default __webpack_public_path__ + "static/sfb-logo-en-1a6343aa8b4e9c03d9e778dff6812908.png";